
import { baseUrl } from "../../constants";

export default {
    "formTitle": "Add Work Permit",
    "tableTitle": "Work Permit List",
    "apiDetails": {
        startUp: () => {
        },
        list: {
            url: `${baseUrl}/api/mms/work_permit/list`,
            payload: {
                "search": "",
                "offset": 0,
                "limit": 50,
                "sort": "DESC",
                "column": "id"
            }
        },
        add: `${baseUrl}/api/mms/work_permit`,
        edit: `${baseUrl}/api/mms/work_permit/edit`,
        delete: `${baseUrl}/api/mms/work_permit/remove`
    },
    "tableCol": [
        {
            name: 'Work Permit',
            selector: row => row.name,
            sortable: true
        }
    ],
    "formData": [
        {
            "formType": "flex",
            "formFields": [
                {
                    type: 'text',
                    label: 'Work Permit',
                    name: 'name',
                    "required": true
                }
            ]
        }
    ],
    "mockData": [{
        "workPermit": "dgdg"
    }]
}